/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { Button, ConfigProvider } from "antd";
import { Link, Redirect } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import Reasons from "./Reasons";
import { accountBaseUrl } from "../../helpers/account";
import * as actions from "./actions";
import { getAppointmentReasons } from "./reducers";
import { getAvailabilityRequests, getPatientType } from "../Booking/reducers";
import { clearBooking } from "modules/Booking/actions";
import { ButtonSize } from "../../GlobalConfig";
import ContentContainer from "../../components/ContentContainer";
import uniqBy from "lodash/uniqBy";
import { ArrowLeftOutlined } from "@ant-design/icons";
import usePageView from "../../hooks/usePageView";
import { trackButtonClick } from "utils/analytics";

const Services = ({
	// fetchCatalogueItemsRequest,
	match,
	availabilityRequests,
	clearBooking,
	patientType,
}) => {
	useEffect(() => {
		clearBooking();
	}, []);

	// Track page view with step info
	usePageView("Service Selection", 2, "service_selection", 40);

	const { params } = match;
	const { locationId: practiceId, practitionerId } = params;

	const uniqueAvailabilityRequests = uniqBy(availabilityRequests, "reasonId");
	const currentLocation = useSelector((state) => state?.locations?.currentLocation)

	// Redirect to patient type selection if not yet chosen
	if (!patientType) {
		const base = `${accountBaseUrl}/locations/${practiceId}`;
		if (practitionerId) {
			return <Redirect to={`${base}/practitioner/${practitionerId}/patient-type`} />;
		}
		return <Redirect to={`${base}/patient-type`} />;
	}

	return (
		<ConfigProvider themeColor={currentLocation?.themeColor}>
			<ContentContainer
				pageTitle="What would you like to book?"
				themeColor={currentLocation?.themeColor}
				step="2"
				showNext={false}
				stepPercentage={40}
				backButton={
					<Link to={`${accountBaseUrl}/locations/${practiceId}/patient-type`}>
						<Button shape="circle" type="text" icon={<ArrowLeftOutlined />} />
					</Link>
				}
				extra={
					availabilityRequests &&
					uniqueAvailabilityRequests.length > 0 && (
						<Link
							className="ml-lg"
							to={`${accountBaseUrl}/locations/${practiceId}/date`}
							onClick={() => trackButtonClick('next_to_date_button', {
								services_selected: uniqueAvailabilityRequests.length,
							})}
						>
							<Button
								size={ButtonSize}
								style={{
									background: currentLocation?.themeColor
										? currentLocation.themeColor
										: "#000",
									color: "#fff",
									borderColor: currentLocation?.themeColor
										? currentLocation.themeColor
										: "#fff",
								}}
								type="primary"
							>
								Next
							</Button>
						</Link>
					)
				}
			>
				<Reasons
					practiceId={practiceId}
					practitionerId={practitionerId}
					themeColor={currentLocation?.themeColor}
				/>
			</ContentContainer>
		</ConfigProvider>
	);
};

const mapStateToProps = (state) => ({
	reasons: getAppointmentReasons(state.appointmentReasons),
	availabilityRequests: getAvailabilityRequests(state.booking),
	patientType: getPatientType(state.booking),
});

export default connect(mapStateToProps, { ...actions, clearBooking })(
	Services,
);
